import type { HTMLAttributes, ReactElement, ReactNode } from 'react';

export interface PanelHeaderProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  kicker?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  headingLevel?: 1 | 2 | 3;
  headingId?: string;
  kickerClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
}

export function PanelHeader({
  kicker,
  title,
  description,
  actions,
  headingLevel = 1,
  headingId,
  className,
  kickerClassName,
  titleClassName,
  descriptionClassName,
  ...props
}: PanelHeaderProps): ReactElement {
  const Heading = `h${headingLevel}` as 'h1' | 'h2' | 'h3';
  return (
    <header
      {...props}
      className={['cards-kit-panel-header', className].filter(Boolean).join(' ')}
    >
      <div className="cards-kit-panel-header-copy">
        {kicker === undefined ? null : (
          <div
            className={['cards-kit-panel-header-kicker', kickerClassName]
              .filter(Boolean).join(' ')}
          >
            {kicker}
          </div>
        )}
        {title === null || title === undefined ? null : (
          <Heading
            id={headingId}
            className={['cards-kit-panel-header-title', titleClassName]
              .filter(Boolean).join(' ')}
          >
            {title}
          </Heading>
        )}
        {description === undefined ? null : (
          <p
            className={['cards-kit-panel-header-description', descriptionClassName]
              .filter(Boolean).join(' ')}
          >
            {description}
          </p>
        )}
      </div>
      {actions === undefined ? null : (
        <div className="cards-kit-panel-header-actions">{actions}</div>
      )}
    </header>
  );
}
